import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { getConfig } from '@edx/frontend-platform';

export const fetchLearnerCourseSchedules = async () => {
  const url = `${getConfig().LMS_BASE_URL}/blendxapi/learner/schedule`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};
